import React, { useState, useEffect } from 'react';
import './Dashboard.css';

const API_URL = process.env.REACT_APP_API_URL;

const Dashboard = () => {
  const [submissions, setSubmissions] = useState([]);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('all'); // all, today, yesterday, week
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchSubmissions = async () => {
      setLoading(true);
      try {
          const params = new URLSearchParams({
              search,
              filter,
              page,
              limit: 10 // ou une autre valeur
          });
          const response = await fetch(`${API_URL}/api/submissions?${params.toString()}`);
          if (!response.ok) throw new Error('Network response was not ok');
          const data = await response.json();
          if (Array.isArray(data.submissions)) {
              setSubmissions(data.submissions);
              setTotalPages(data.totalPages);
          }
        } catch (error) {
          console.error('Failed to fetch submissions:', error);
        } finally {
            setLoading(false);
        }
    }

    fetchSubmissions();
  }, [search, filter, page]);

  const handleSearchChange = (e) => {
      setSearch(e.target.value);
      setPage(1); // Reset page on new search
  }
  
  const handleFilterChange = (newFilter) => {
      setFilter(newFilter);
      setPage(1); // Reset page on new filter
  }

  return (
    <div className="dashboard">
      <h2>Liste des envois</h2>
      
      <div className="controls-container">
        <div className="search-bar">
          <input 
            type="text" 
            placeholder="Rechercher par nom de chauffeur..."
            value={search}
            onChange={handleSearchChange}
          />
        </div>
        <div className="filter-buttons">
          <button onClick={() => handleFilterChange('all')} className={filter === 'all' ? 'active' : ''}>Tout</button>
          <button onClick={() => handleFilterChange('today')} className={filter === 'today' ? 'active' : ''}>Aujourd'hui</button>
          <button onClick={() => handleFilterChange('yesterday')} className={filter === 'yesterday' ? 'active' : ''}>Hier</button>
          <button onClick={() => handleFilterChange('week')} className={filter === 'week' ? 'active' : ''}>Cette semaine</button>
        </div>
      </div>

      <div className="table-panel">
        <table>
          <thead>
            <tr>
              <th>Chauffeur</th>
              <th>Date</th>
              <th>Heure</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
                <tr><td colSpan="3">Chargement...</td></tr>
            ) : submissions.length > 0 ? submissions.map(sub => {
              const submissionDate = new Date(sub.submission_time);
              return (
                <tr key={sub.id}>
                  <td>{sub.driverName}</td>
                  <td>{submissionDate.toLocaleDateString('fr-FR')}</td>
                  <td>{submissionDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</td>
                </tr>
              );
            }) : (
              <tr>
                <td colSpan="3">Aucun envoi correspondant aux critères.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

       <div className="pagination-controls">
            <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}>Précédent</button>
            <span>Page {page} sur {totalPages}</span>
            <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}>Suivant</button>
        </div>
    </div>
  );
};

export default Dashboard;
